export function getAuthRedirectURL(pathname, search, authRoute) {
  const routeSuffix = `/${authRoute}`;
  const normalizedPathname = pathname.endsWith("/") && pathname !== "/" ? pathname.slice(0, -1) : pathname;
  const parentPath = normalizedPathname.endsWith(routeSuffix)
    ? normalizedPathname.slice(0, -routeSuffix.length) || "/"
    : "/";

  return parentPath + search;
}
